var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "27", height: "27", viewBox: "0 0 27 27", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { stroke: "#424242", strokeWidth: "2.4", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
      React.createElement("path", { d: "M9.692 10.577v5.84M13.25 11.667V21M8.795 9.82L2 2h23l-8.364 9.2V25" })
    )
  );
});